import { fromEvent, Observable, Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd,NavigationStart, Router,ActivatedRoute,UrlSegment } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService } from './core/_base/layout';
// Layout
import { TranslationService } from './core/_base/layout';
// language list
import { locale as frLang } from './core/_config/i18n/fr';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { StateService } from './services/state.service';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	// Public properties
	title = 'Atyl AssMat';
	loader: boolean;
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	offlineEvent: Observable<Event>;
	onlineEvent: Observable<Event>;
	subscriptions: Subscription[] = [];

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(private translationService: TranslationService,
				private router: Router,
				private activatedRoute: ActivatedRoute,
				private layoutConfigService: LayoutConfigService,
				private splashScreenService: SplashScreenService,
				private stateService: StateService) {
		registerLocaleData(localeFr,'fr');
		// register translations
		this.translationService.loadTranslations(frLang);
		console.log(this.translationService.getSelectedLanguage());
		this.translationService.setLanguage("fr");
		console.log(this.translationService.getSelectedLanguage());

	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// enable/disable loader
		this.loader = this.layoutConfigService.getConfig('loader.enabled');

		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) { 
				console.log("AppComponent routerSubscription NavigationStart",event,localStorage.getItem("AtylreturnUrl"));
				
				const url:string= event.url;
				if (!url.includes("/login") 
					&& !url.includes("/dashboard")
				   && !url.includes("/client")
					)
					localStorage.setItem('AtylreturnUrl',url) 
				
			}
			if (event instanceof NavigationEnd) {
				// hide splash screen
				this.splashScreenService.hide();
				/*const url:string= event.urlAfterRedirects;
				if (!url.includes("/login") 
					&& !url.includes("/dashboard")
					)
					localStorage.setItem('AtylreturnUrl',url) 
					
			    */console.log("AppComponent routerSubscription",event,localStorage.getItem("AtylreturnUrl"));
			  
				// scroll to top on every route change
				window.scrollTo(0, 0);
			}
		});
		this.unsubscribe.push(routerSubscription);
		this.handleAppConnectivityChanges();
	}
	

	private handleAppConnectivityChanges(): void {
		this.onlineEvent = fromEvent(window, 'online');
		this.offlineEvent = fromEvent(window, 'offline');
	
		this.unsubscribe.push(this.onlineEvent.subscribe((e) => {
		  // handle online mode
			  this.stateService.updateOnline(true);
		}));
	
		this.unsubscribe.push(this.offlineEvent.subscribe((e) => {
		  // handle offline mode
			  this.stateService.updateOnline(false);
		}));
	  }
	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}
}
